// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: common/auth.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

export const protobufPackage = 'common.auth'

export enum SensitiveAction {
  SENSITIVE_ACTION_UNSPECIFIED = 0,
  SENSITIVE_ACTION_CHANGE_PASSWORD = 1,
  SENSITIVE_ACTION_DELETE_PASSKEY = 2,
  /**
   * SENSITIVE_ACTION_CREATE_API_KEY - Minting a data API key. A key outlives every session-kill lever the
   * account has — password reset, sign-out-everywhere, JWT rotation — and is
   * revoked only from the key list, so a stolen session must not be able to
   * convert itself into durable access without re-proving the account.
   */
  SENSITIVE_ACTION_CREATE_API_KEY = 3,
  /**
   * SENSITIVE_ACTION_UPDATE_API_BILLING - Raising or removing the data API spend limit, or turning on / changing
   * auto refill. Either lets a stolen session charge the saved card without
   * the card holder present.
   */
  SENSITIVE_ACTION_UPDATE_API_BILLING = 4,
  /**
   * SENSITIVE_ACTION_ADD_PASSKEY - Enrolling a passkey (`SetupPasskey`). A passkey signs in with no password
   * and no TOTP, so a stolen session must not be able to add its own.
   */
  SENSITIVE_ACTION_ADD_PASSKEY = 5,
  UNRECOGNIZED = -1,
}

export function sensitiveActionFromJSON(object: any): SensitiveAction {
  switch (object) {
    case 0:
    case 'SENSITIVE_ACTION_UNSPECIFIED':
      return SensitiveAction.SENSITIVE_ACTION_UNSPECIFIED
    case 1:
    case 'SENSITIVE_ACTION_CHANGE_PASSWORD':
      return SensitiveAction.SENSITIVE_ACTION_CHANGE_PASSWORD
    case 2:
    case 'SENSITIVE_ACTION_DELETE_PASSKEY':
      return SensitiveAction.SENSITIVE_ACTION_DELETE_PASSKEY
    case 3:
    case 'SENSITIVE_ACTION_CREATE_API_KEY':
      return SensitiveAction.SENSITIVE_ACTION_CREATE_API_KEY
    case 4:
    case 'SENSITIVE_ACTION_UPDATE_API_BILLING':
      return SensitiveAction.SENSITIVE_ACTION_UPDATE_API_BILLING
    case 5:
    case 'SENSITIVE_ACTION_ADD_PASSKEY':
      return SensitiveAction.SENSITIVE_ACTION_ADD_PASSKEY
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SensitiveAction.UNRECOGNIZED
  }
}

export function sensitiveActionToJSON(object: SensitiveAction): string {
  switch (object) {
    case SensitiveAction.SENSITIVE_ACTION_UNSPECIFIED:
      return 'SENSITIVE_ACTION_UNSPECIFIED'
    case SensitiveAction.SENSITIVE_ACTION_CHANGE_PASSWORD:
      return 'SENSITIVE_ACTION_CHANGE_PASSWORD'
    case SensitiveAction.SENSITIVE_ACTION_DELETE_PASSKEY:
      return 'SENSITIVE_ACTION_DELETE_PASSKEY'
    case SensitiveAction.SENSITIVE_ACTION_CREATE_API_KEY:
      return 'SENSITIVE_ACTION_CREATE_API_KEY'
    case SensitiveAction.SENSITIVE_ACTION_UPDATE_API_BILLING:
      return 'SENSITIVE_ACTION_UPDATE_API_BILLING'
    case SensitiveAction.SENSITIVE_ACTION_ADD_PASSKEY:
      return 'SENSITIVE_ACTION_ADD_PASSKEY'
    case SensitiveAction.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/** User information */
export interface User {
  userId: string
  email: string
  emailVerified: boolean
  isActive: boolean
  createdAt: string
  updatedAt: string
  lastLogin?: string | undefined
  /** Google OAuth sub claim */
  googleId?: string | undefined
  /**
   * True unless the account signed up via Google and never set a password.
   * A passkey does NOT change this — passkeys never replace the password,
   * they only block password-based login (see handle_login).
   */
  hasPassword: boolean
}

/** User-Account relationship */
export interface UserAccount {
  userId: string
  accountId: string
  isActive: boolean
  createdAt: string
}

/** Authentication request/response messages */
export interface LoginRequest {
  email: string
  password: string
  /**
   * Opaque client-generated UUID identifying the physical device/browser
   * profile. Must persist with the same storage lifetime as the refresh token.
   */
  deviceId?: string | undefined
}

export interface LoginResponse {
  success: boolean
  accessToken?: string | undefined
  refreshToken?: string | undefined
  user?: User | undefined
  errorMessage?: string | undefined
  /** Indicates if 2FA verification is required */
  requires2fa: boolean
  /** Temporary token for 2FA verification */
  tempToken?: string | undefined
}

export interface SignupRequest {
  email: string
  password: string
}

export interface SignupResponse {
  success: boolean
  user?: User | undefined
  errorMessage?: string | undefined
}

export interface RefreshTokenRequest {
  refreshToken: string
  deviceId?: string | undefined
}

export interface RefreshTokenResponse {
  success: boolean
  accessToken?: string | undefined
  refreshToken?: string | undefined
  errorMessage?: string | undefined
}

/** 2FA Setup and Management */
export interface Setup2faRequest {}

export interface Setup2faResponse {
  success: boolean
  /** Base32 encoded secret for QR code */
  secret?: string | undefined
  backupCodes: string[]
  errorMessage?: string | undefined
}

export interface Confirm2faSetupRequest {
  totpCode: string
}

export interface Confirm2faSetupResponse {
  success: boolean
  message?: string | undefined
}

export interface Verify2faRequest {
  totpCode: string
}

export interface Verify2faResponse {
  success: boolean
  errorMessage?: string | undefined
}

/** 2FA Login Verification (used after initial login when 2FA is required) */
export interface Verify2faLoginRequest {
  tempToken: string
  totpCode?: string | undefined
  backupCode?: string | undefined
  deviceId?: string | undefined
}

export interface Verify2faLoginResponse {
  success: boolean
  accessToken?: string | undefined
  refreshToken?: string | undefined
  user?: User | undefined
  errorMessage?: string | undefined
}

export interface Disable2faRequest {
  currentPassword?: string | undefined
  totpCode?: string | undefined
  backupCode?: string | undefined
}

export interface Disable2faResponse {
  success: boolean
  errorMessage?: string | undefined
  /**
   * Populated on success: the caller's other sessions were invalidated and its
   * own session reissued fresh tokens (min_token_iat bump kills the old ones).
   */
  accessToken?: string | undefined
  refreshToken?: string | undefined
  accessExpiresIn?: string | undefined
  refreshExpiresIn?: string | undefined
}

/** Empty - user must be authenticated */
export interface Get2faBackupCodesRequest {}

export interface Get2faBackupCodesResponse {
  success: boolean
  backupCodes: string[]
  errorMessage?: string | undefined
}

/** Passkey Setup and Management */
export interface SetupPasskeyRequest {
  /**
   * Step-up, the same shape `CreateApiKeyRequest` uses. A passkey is a login
   * that needs neither the password nor TOTP, and it outlives every
   * session-kill lever except password reset, so enrolling one re-proves the
   * account rather than trusting the session.
   *
   * Send the password AND the factor the account has. With TOTP enabled that
   * is `totp_code` (or `backup_code`); otherwise call
   * `SendStepUpCode(SENSITIVE_ACTION_ADD_PASSKEY)` first and send
   * `email_code`. Every attempt counts against the account's step-up throttle.
   */
  currentPassword: string
  totpCode?: string | undefined
  backupCode?: string | undefined
  emailCode?: string | undefined
}

export interface SetupPasskeyResponse {
  success: boolean
  /** WebAuthn challenge */
  challenge?: string | undefined
  /**
   * Stable account id, used as the WebAuthn user handle (user.id). Password
   * managers key passkeys on (rpId, user.id), so this must not vary between
   * registrations for the same account.
   */
  userId?: string | undefined
  errorMessage?: string | undefined
  /** Setup session id; echo back in ConfirmPasskeySetupRequest.session_id. */
  sessionId?: string | undefined
  /** Credential ids already registered for this user, for excludeCredentials. */
  existingCredentialIds: string[]
}

export interface ConfirmPasskeySetupRequest {
  credentialId: string
  publicKey: string
  attestationObject: string
  clientDataJson: string
  deviceName: string
  /** Session ID from initial setup request */
  sessionId: string
}

export interface ConfirmPasskeySetupResponse {
  success: boolean
  errorMessage?: string | undefined
}

export interface PasskeyLoginRequest {
  /** Optional: if provided, filter credentials by user email */
  email?: string | undefined
}

export interface PasskeyLoginResponse {
  success: boolean
  /** WebAuthn challenge for login */
  challenge?: string | undefined
  /** Session ID for login */
  sessionId?: string | undefined
  /** Available credentials for user */
  credentialIds: string[]
  errorMessage?: string | undefined
}

export interface ConfirmPasskeyLoginRequest {
  sessionId: string
  credentialId: string
  authenticatorData: string
  clientDataJson: string
  signature: string
  deviceId?: string | undefined
}

export interface ConfirmPasskeyLoginResponse {
  success: boolean
  accessToken?: string | undefined
  refreshToken?: string | undefined
  user?: User | undefined
  errorMessage?: string | undefined
}

export interface DeletePasskeyRequest {
  credentialId: string
  currentPassword?: string | undefined
  totpCode?: string | undefined
  backupCode?: string | undefined
  emailCode?: string | undefined
}

export interface DeletePasskeyResponse {
  success: boolean
  errorMessage?: string | undefined
  accessToken?: string | undefined
  refreshToken?: string | undefined
  accessExpiresIn?: string | undefined
  refreshExpiresIn?: string | undefined
}

export interface SendStepUpCodeRequest {
  action: SensitiveAction
}

export interface SendStepUpCodeResponse {
  success: boolean
  errorMessage?: string | undefined
}

/** Empty - user must be authenticated */
export interface GetUserPasskeysRequest {}

export interface PasskeyInfo {
  credentialId: string
  credentialName: string
  createdAt: string
  lastUsedAt?: string | undefined
}

export interface GetUserPasskeysResponse {
  success: boolean
  passkeys: PasskeyInfo[]
  errorMessage?: string | undefined
}

/** Enhanced login response with 2FA requirements */
export interface EnhancedLoginResponse {
  success: boolean
  requires2fa: boolean
  requiresPasskey: boolean
  /** For multi-step auth */
  sessionId?: string | undefined
  /** Only if auth fully complete */
  accessToken?: string | undefined
  refreshToken?: string | undefined
  user?: User | undefined
  errorMessage?: string | undefined
}

/** Google OAuth Login */
export interface GoogleLoginRequest {
  /** Google ID token from frontend */
  idToken: string
  deviceId?: string | undefined
}

export interface GoogleLoginResponse {
  success: boolean
  accessToken?: string | undefined
  refreshToken?: string | undefined
  user?: User | undefined
  errorMessage?: string | undefined
  /** Indicates if this was account creation vs login */
  isNewUser: boolean
  /**
   * The account has TOTP on: no tokens are issued. Finish the sign-in with
   * `Verify2faLoginRequest` (temp_token + totp_code or backup_code), as after a password
   * login that answered `requires_2fa`. A client that ignores this field sees
   * `success = true` with no `access_token`.
   */
  requires2fa: boolean
  /** Present only with `requires_2fa`; short-lived. */
  tempToken?: string | undefined
}

/** List wrappers */
export interface UserList {
  users: User[]
}

export interface UserAccountList {
  userAccounts: UserAccount[]
}

export interface ChangePasswordRequest {
  currentPassword: string
  newPassword: string
  totpCode?: string | undefined
  emailCode?: string | undefined
  backupCode?: string | undefined
}

export interface ChangePasswordResponse {
  success: boolean
  errorMessage?: string | undefined
  accessToken?: string | undefined
  refreshToken?: string | undefined
  accessExpiresIn?: string | undefined
  refreshExpiresIn?: string | undefined
}

export interface SessionInfo {
  sessionId: string
  deviceLabel: string
  ip: string
  geoCountry?: string | undefined
  geoCity?: string | undefined
  createdAt: string
  lastUsedAt: string
  isCurrent: boolean
}

export interface ListSessionsRequest {}

export interface ListSessionsResponse {
  success: boolean
  sessions: SessionInfo[]
  errorMessage?: string | undefined
}

export interface RevokeSessionRequest {
  sessionId: string
}

export interface RevokeSessionResponse {
  success: boolean
  errorMessage?: string | undefined
}

export interface LogoutRequest {}

export interface LogoutResponse {
  success: boolean
  errorMessage?: string | undefined
}

export interface RevokeAllOtherSessionsRequest {}

export interface RevokeAllOtherSessionsResponse {
  success: boolean
  errorMessage?: string | undefined
  accessToken?: string | undefined
  refreshToken?: string | undefined
  accessExpiresIn?: string | undefined
  refreshExpiresIn?: string | undefined
}

function createBaseUser(): User {
  return {
    userId: '',
    email: '',
    emailVerified: false,
    isActive: false,
    createdAt: '0',
    updatedAt: '0',
    lastLogin: undefined,
    googleId: undefined,
    hasPassword: false,
  }
}

export const User: MessageFns<User> = {
  encode(message: User, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== '') {
      writer.uint32(10).string(message.userId)
    }
    if (message.email !== '') {
      writer.uint32(18).string(message.email)
    }
    if (message.emailVerified !== false) {
      writer.uint32(24).bool(message.emailVerified)
    }
    if (message.isActive !== false) {
      writer.uint32(40).bool(message.isActive)
    }
    if (message.createdAt !== '0') {
      writer.uint32(48).int64(message.createdAt)
    }
    if (message.updatedAt !== '0') {
      writer.uint32(56).int64(message.updatedAt)
    }
    if (message.lastLogin !== undefined) {
      writer.uint32(64).int64(message.lastLogin)
    }
    if (message.googleId !== undefined) {
      writer.uint32(74).string(message.googleId)
    }
    if (message.hasPassword !== false) {
      writer.uint32(80).bool(message.hasPassword)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): User {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUser()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.email = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.emailVerified = reader.bool()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.isActive = reader.bool()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.updatedAt = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.lastLogin = reader.int64().toString()
          continue
        }
        case 9: {
          if (tag !== 74) {
            break
          }

          message.googleId = reader.string()
          continue
        }
        case 10: {
          if (tag !== 80) {
            break
          }

          message.hasPassword = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): User {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      email: isSet(object.email) ? globalThis.String(object.email) : '',
      emailVerified: isSet(object.emailVerified)
        ? globalThis.Boolean(object.emailVerified)
        : isSet(object.email_verified)
          ? globalThis.Boolean(object.email_verified)
          : false,
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
          ? globalThis.Boolean(object.is_active)
          : false,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
          ? globalThis.String(object.updated_at)
          : '0',
      lastLogin: isSet(object.lastLogin)
        ? globalThis.String(object.lastLogin)
        : isSet(object.last_login)
          ? globalThis.String(object.last_login)
          : undefined,
      googleId: isSet(object.googleId)
        ? globalThis.String(object.googleId)
        : isSet(object.google_id)
          ? globalThis.String(object.google_id)
          : undefined,
      hasPassword: isSet(object.hasPassword)
        ? globalThis.Boolean(object.hasPassword)
        : isSet(object.has_password)
          ? globalThis.Boolean(object.has_password)
          : false,
    }
  },

  toJSON(message: User): unknown {
    const obj: any = {}
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.email !== '') {
      obj.email = message.email
    }
    if (message.emailVerified !== false) {
      obj.emailVerified = message.emailVerified
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.updatedAt !== '0') {
      obj.updatedAt = message.updatedAt
    }
    if (message.lastLogin !== undefined) {
      obj.lastLogin = message.lastLogin
    }
    if (message.googleId !== undefined) {
      obj.googleId = message.googleId
    }
    if (message.hasPassword !== false) {
      obj.hasPassword = message.hasPassword
    }
    return obj
  },

  create<I extends Exact<DeepPartial<User>, I>>(base?: I): User {
    return User.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<User>, I>>(object: I): User {
    const message = createBaseUser()
    message.userId = object.userId ?? ''
    message.email = object.email ?? ''
    message.emailVerified = object.emailVerified ?? false
    message.isActive = object.isActive ?? false
    message.createdAt = object.createdAt ?? '0'
    message.updatedAt = object.updatedAt ?? '0'
    message.lastLogin = object.lastLogin ?? undefined
    message.googleId = object.googleId ?? undefined
    message.hasPassword = object.hasPassword ?? false
    return message
  },
}

function createBaseUserAccount(): UserAccount {
  return { userId: '', accountId: '', isActive: false, createdAt: '0' }
}

export const UserAccount: MessageFns<UserAccount> = {
  encode(message: UserAccount, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userId !== '') {
      writer.uint32(10).string(message.userId)
    }
    if (message.accountId !== '') {
      writer.uint32(18).string(message.accountId)
    }
    if (message.isActive !== false) {
      writer.uint32(24).bool(message.isActive)
    }
    if (message.createdAt !== '0') {
      writer.uint32(32).int64(message.createdAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserAccount {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUserAccount()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accountId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.isActive = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UserAccount {
    return {
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : '',
      accountId: isSet(object.accountId)
        ? globalThis.String(object.accountId)
        : isSet(object.account_id)
          ? globalThis.String(object.account_id)
          : '',
      isActive: isSet(object.isActive)
        ? globalThis.Boolean(object.isActive)
        : isSet(object.is_active)
          ? globalThis.Boolean(object.is_active)
          : false,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
    }
  },

  toJSON(message: UserAccount): unknown {
    const obj: any = {}
    if (message.userId !== '') {
      obj.userId = message.userId
    }
    if (message.accountId !== '') {
      obj.accountId = message.accountId
    }
    if (message.isActive !== false) {
      obj.isActive = message.isActive
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UserAccount>, I>>(base?: I): UserAccount {
    return UserAccount.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UserAccount>, I>>(object: I): UserAccount {
    const message = createBaseUserAccount()
    message.userId = object.userId ?? ''
    message.accountId = object.accountId ?? ''
    message.isActive = object.isActive ?? false
    message.createdAt = object.createdAt ?? '0'
    return message
  },
}

function createBaseLoginRequest(): LoginRequest {
  return { email: '', password: '', deviceId: undefined }
}

export const LoginRequest: MessageFns<LoginRequest> = {
  encode(message: LoginRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== '') {
      writer.uint32(10).string(message.email)
    }
    if (message.password !== '') {
      writer.uint32(18).string(message.password)
    }
    if (message.deviceId !== undefined) {
      writer.uint32(26).string(message.deviceId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoginRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLoginRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.email = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.password = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.deviceId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LoginRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : '',
      password: isSet(object.password) ? globalThis.String(object.password) : '',
      deviceId: isSet(object.deviceId)
        ? globalThis.String(object.deviceId)
        : isSet(object.device_id)
          ? globalThis.String(object.device_id)
          : undefined,
    }
  },

  toJSON(message: LoginRequest): unknown {
    const obj: any = {}
    if (message.email !== '') {
      obj.email = message.email
    }
    if (message.password !== '') {
      obj.password = message.password
    }
    if (message.deviceId !== undefined) {
      obj.deviceId = message.deviceId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LoginRequest>, I>>(base?: I): LoginRequest {
    return LoginRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LoginRequest>, I>>(object: I): LoginRequest {
    const message = createBaseLoginRequest()
    message.email = object.email ?? ''
    message.password = object.password ?? ''
    message.deviceId = object.deviceId ?? undefined
    return message
  },
}

function createBaseLoginResponse(): LoginResponse {
  return {
    success: false,
    accessToken: undefined,
    refreshToken: undefined,
    user: undefined,
    errorMessage: undefined,
    requires2fa: false,
    tempToken: undefined,
  }
}

export const LoginResponse: MessageFns<LoginResponse> = {
  encode(message: LoginResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(18).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(26).string(message.refreshToken)
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(34).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(42).string(message.errorMessage)
    }
    if (message.requires2fa !== false) {
      writer.uint32(48).bool(message.requires2fa)
    }
    if (message.tempToken !== undefined) {
      writer.uint32(58).string(message.tempToken)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LoginResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLoginResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.user = User.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.requires2fa = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.tempToken = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LoginResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      requires2fa: isSet(object.requires2fa)
        ? globalThis.Boolean(object.requires2fa)
        : isSet(object.requires_2fa)
          ? globalThis.Boolean(object.requires_2fa)
          : false,
      tempToken: isSet(object.tempToken)
        ? globalThis.String(object.tempToken)
        : isSet(object.temp_token)
          ? globalThis.String(object.temp_token)
          : undefined,
    }
  },

  toJSON(message: LoginResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.requires2fa !== false) {
      obj.requires2fa = message.requires2fa
    }
    if (message.tempToken !== undefined) {
      obj.tempToken = message.tempToken
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LoginResponse>, I>>(base?: I): LoginResponse {
    return LoginResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LoginResponse>, I>>(object: I): LoginResponse {
    const message = createBaseLoginResponse()
    message.success = object.success ?? false
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.user =
      object.user !== undefined && object.user !== null ? User.fromPartial(object.user) : undefined
    message.errorMessage = object.errorMessage ?? undefined
    message.requires2fa = object.requires2fa ?? false
    message.tempToken = object.tempToken ?? undefined
    return message
  },
}

function createBaseSignupRequest(): SignupRequest {
  return { email: '', password: '' }
}

export const SignupRequest: MessageFns<SignupRequest> = {
  encode(message: SignupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== '') {
      writer.uint32(10).string(message.email)
    }
    if (message.password !== '') {
      writer.uint32(18).string(message.password)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSignupRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.email = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.password = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SignupRequest {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : '',
      password: isSet(object.password) ? globalThis.String(object.password) : '',
    }
  },

  toJSON(message: SignupRequest): unknown {
    const obj: any = {}
    if (message.email !== '') {
      obj.email = message.email
    }
    if (message.password !== '') {
      obj.password = message.password
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SignupRequest>, I>>(base?: I): SignupRequest {
    return SignupRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SignupRequest>, I>>(object: I): SignupRequest {
    const message = createBaseSignupRequest()
    message.email = object.email ?? ''
    message.password = object.password ?? ''
    return message
  },
}

function createBaseSignupResponse(): SignupResponse {
  return { success: false, user: undefined, errorMessage: undefined }
}

export const SignupResponse: MessageFns<SignupResponse> = {
  encode(message: SignupResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(18).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(26).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SignupResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSignupResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.user = User.decode(reader, reader.uint32())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SignupResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: SignupResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SignupResponse>, I>>(base?: I): SignupResponse {
    return SignupResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SignupResponse>, I>>(object: I): SignupResponse {
    const message = createBaseSignupResponse()
    message.success = object.success ?? false
    message.user =
      object.user !== undefined && object.user !== null ? User.fromPartial(object.user) : undefined
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseRefreshTokenRequest(): RefreshTokenRequest {
  return { refreshToken: '', deviceId: undefined }
}

export const RefreshTokenRequest: MessageFns<RefreshTokenRequest> = {
  encode(message: RefreshTokenRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.refreshToken !== '') {
      writer.uint32(10).string(message.refreshToken)
    }
    if (message.deviceId !== undefined) {
      writer.uint32(18).string(message.deviceId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RefreshTokenRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRefreshTokenRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.deviceId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RefreshTokenRequest {
    return {
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : '',
      deviceId: isSet(object.deviceId)
        ? globalThis.String(object.deviceId)
        : isSet(object.device_id)
          ? globalThis.String(object.device_id)
          : undefined,
    }
  },

  toJSON(message: RefreshTokenRequest): unknown {
    const obj: any = {}
    if (message.refreshToken !== '') {
      obj.refreshToken = message.refreshToken
    }
    if (message.deviceId !== undefined) {
      obj.deviceId = message.deviceId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RefreshTokenRequest>, I>>(base?: I): RefreshTokenRequest {
    return RefreshTokenRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RefreshTokenRequest>, I>>(
    object: I
  ): RefreshTokenRequest {
    const message = createBaseRefreshTokenRequest()
    message.refreshToken = object.refreshToken ?? ''
    message.deviceId = object.deviceId ?? undefined
    return message
  },
}

function createBaseRefreshTokenResponse(): RefreshTokenResponse {
  return {
    success: false,
    accessToken: undefined,
    refreshToken: undefined,
    errorMessage: undefined,
  }
}

export const RefreshTokenResponse: MessageFns<RefreshTokenResponse> = {
  encode(message: RefreshTokenResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(18).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(26).string(message.refreshToken)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(34).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RefreshTokenResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRefreshTokenResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RefreshTokenResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: RefreshTokenResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RefreshTokenResponse>, I>>(base?: I): RefreshTokenResponse {
    return RefreshTokenResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RefreshTokenResponse>, I>>(
    object: I
  ): RefreshTokenResponse {
    const message = createBaseRefreshTokenResponse()
    message.success = object.success ?? false
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseSetup2faRequest(): Setup2faRequest {
  return {}
}

export const Setup2faRequest: MessageFns<Setup2faRequest> = {
  encode(_: Setup2faRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Setup2faRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSetup2faRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): Setup2faRequest {
    return {}
  },

  toJSON(_: Setup2faRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<Setup2faRequest>, I>>(base?: I): Setup2faRequest {
    return Setup2faRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Setup2faRequest>, I>>(_: I): Setup2faRequest {
    const message = createBaseSetup2faRequest()
    return message
  },
}

function createBaseSetup2faResponse(): Setup2faResponse {
  return { success: false, secret: undefined, backupCodes: [], errorMessage: undefined }
}

export const Setup2faResponse: MessageFns<Setup2faResponse> = {
  encode(message: Setup2faResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.secret !== undefined) {
      writer.uint32(18).string(message.secret)
    }
    for (const v of message.backupCodes) {
      writer.uint32(26).string(v!)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(34).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Setup2faResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSetup2faResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.secret = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.backupCodes.push(reader.string())
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Setup2faResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      secret: isSet(object.secret) ? globalThis.String(object.secret) : undefined,
      backupCodes: globalThis.Array.isArray(object?.backupCodes)
        ? object.backupCodes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.backup_codes)
          ? object.backup_codes.map((e: any) => globalThis.String(e))
          : [],
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: Setup2faResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.secret !== undefined) {
      obj.secret = message.secret
    }
    if (message.backupCodes?.length) {
      obj.backupCodes = message.backupCodes
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Setup2faResponse>, I>>(base?: I): Setup2faResponse {
    return Setup2faResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Setup2faResponse>, I>>(object: I): Setup2faResponse {
    const message = createBaseSetup2faResponse()
    message.success = object.success ?? false
    message.secret = object.secret ?? undefined
    message.backupCodes = object.backupCodes?.map((e) => e) || []
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseConfirm2faSetupRequest(): Confirm2faSetupRequest {
  return { totpCode: '' }
}

export const Confirm2faSetupRequest: MessageFns<Confirm2faSetupRequest> = {
  encode(message: Confirm2faSetupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totpCode !== '') {
      writer.uint32(10).string(message.totpCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Confirm2faSetupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirm2faSetupRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.totpCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Confirm2faSetupRequest {
    return {
      totpCode: isSet(object.totpCode)
        ? globalThis.String(object.totpCode)
        : isSet(object.totp_code)
          ? globalThis.String(object.totp_code)
          : '',
    }
  },

  toJSON(message: Confirm2faSetupRequest): unknown {
    const obj: any = {}
    if (message.totpCode !== '') {
      obj.totpCode = message.totpCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Confirm2faSetupRequest>, I>>(
    base?: I
  ): Confirm2faSetupRequest {
    return Confirm2faSetupRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Confirm2faSetupRequest>, I>>(
    object: I
  ): Confirm2faSetupRequest {
    const message = createBaseConfirm2faSetupRequest()
    message.totpCode = object.totpCode ?? ''
    return message
  },
}

function createBaseConfirm2faSetupResponse(): Confirm2faSetupResponse {
  return { success: false, message: undefined }
}

export const Confirm2faSetupResponse: MessageFns<Confirm2faSetupResponse> = {
  encode(
    message: Confirm2faSetupResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.message !== undefined) {
      writer.uint32(18).string(message.message)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Confirm2faSetupResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirm2faSetupResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Confirm2faSetupResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
    }
  },

  toJSON(message: Confirm2faSetupResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.message !== undefined) {
      obj.message = message.message
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Confirm2faSetupResponse>, I>>(
    base?: I
  ): Confirm2faSetupResponse {
    return Confirm2faSetupResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Confirm2faSetupResponse>, I>>(
    object: I
  ): Confirm2faSetupResponse {
    const message = createBaseConfirm2faSetupResponse()
    message.success = object.success ?? false
    message.message = object.message ?? undefined
    return message
  },
}

function createBaseVerify2faRequest(): Verify2faRequest {
  return { totpCode: '' }
}

export const Verify2faRequest: MessageFns<Verify2faRequest> = {
  encode(message: Verify2faRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.totpCode !== '') {
      writer.uint32(10).string(message.totpCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Verify2faRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVerify2faRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.totpCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Verify2faRequest {
    return {
      totpCode: isSet(object.totpCode)
        ? globalThis.String(object.totpCode)
        : isSet(object.totp_code)
          ? globalThis.String(object.totp_code)
          : '',
    }
  },

  toJSON(message: Verify2faRequest): unknown {
    const obj: any = {}
    if (message.totpCode !== '') {
      obj.totpCode = message.totpCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Verify2faRequest>, I>>(base?: I): Verify2faRequest {
    return Verify2faRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Verify2faRequest>, I>>(object: I): Verify2faRequest {
    const message = createBaseVerify2faRequest()
    message.totpCode = object.totpCode ?? ''
    return message
  },
}

function createBaseVerify2faResponse(): Verify2faResponse {
  return { success: false, errorMessage: undefined }
}

export const Verify2faResponse: MessageFns<Verify2faResponse> = {
  encode(message: Verify2faResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Verify2faResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVerify2faResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Verify2faResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: Verify2faResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Verify2faResponse>, I>>(base?: I): Verify2faResponse {
    return Verify2faResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Verify2faResponse>, I>>(object: I): Verify2faResponse {
    const message = createBaseVerify2faResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseVerify2faLoginRequest(): Verify2faLoginRequest {
  return { tempToken: '', totpCode: undefined, backupCode: undefined, deviceId: undefined }
}

export const Verify2faLoginRequest: MessageFns<Verify2faLoginRequest> = {
  encode(message: Verify2faLoginRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tempToken !== '') {
      writer.uint32(10).string(message.tempToken)
    }
    if (message.totpCode !== undefined) {
      writer.uint32(18).string(message.totpCode)
    }
    if (message.backupCode !== undefined) {
      writer.uint32(26).string(message.backupCode)
    }
    if (message.deviceId !== undefined) {
      writer.uint32(34).string(message.deviceId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Verify2faLoginRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVerify2faLoginRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.tempToken = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.totpCode = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.backupCode = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.deviceId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Verify2faLoginRequest {
    return {
      tempToken: isSet(object.tempToken)
        ? globalThis.String(object.tempToken)
        : isSet(object.temp_token)
          ? globalThis.String(object.temp_token)
          : '',
      totpCode: isSet(object.totpCode)
        ? globalThis.String(object.totpCode)
        : isSet(object.totp_code)
          ? globalThis.String(object.totp_code)
          : undefined,
      backupCode: isSet(object.backupCode)
        ? globalThis.String(object.backupCode)
        : isSet(object.backup_code)
          ? globalThis.String(object.backup_code)
          : undefined,
      deviceId: isSet(object.deviceId)
        ? globalThis.String(object.deviceId)
        : isSet(object.device_id)
          ? globalThis.String(object.device_id)
          : undefined,
    }
  },

  toJSON(message: Verify2faLoginRequest): unknown {
    const obj: any = {}
    if (message.tempToken !== '') {
      obj.tempToken = message.tempToken
    }
    if (message.totpCode !== undefined) {
      obj.totpCode = message.totpCode
    }
    if (message.backupCode !== undefined) {
      obj.backupCode = message.backupCode
    }
    if (message.deviceId !== undefined) {
      obj.deviceId = message.deviceId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Verify2faLoginRequest>, I>>(base?: I): Verify2faLoginRequest {
    return Verify2faLoginRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Verify2faLoginRequest>, I>>(
    object: I
  ): Verify2faLoginRequest {
    const message = createBaseVerify2faLoginRequest()
    message.tempToken = object.tempToken ?? ''
    message.totpCode = object.totpCode ?? undefined
    message.backupCode = object.backupCode ?? undefined
    message.deviceId = object.deviceId ?? undefined
    return message
  },
}

function createBaseVerify2faLoginResponse(): Verify2faLoginResponse {
  return {
    success: false,
    accessToken: undefined,
    refreshToken: undefined,
    user: undefined,
    errorMessage: undefined,
  }
}

export const Verify2faLoginResponse: MessageFns<Verify2faLoginResponse> = {
  encode(message: Verify2faLoginResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(18).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(26).string(message.refreshToken)
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(34).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(42).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Verify2faLoginResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseVerify2faLoginResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.user = User.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Verify2faLoginResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: Verify2faLoginResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Verify2faLoginResponse>, I>>(
    base?: I
  ): Verify2faLoginResponse {
    return Verify2faLoginResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Verify2faLoginResponse>, I>>(
    object: I
  ): Verify2faLoginResponse {
    const message = createBaseVerify2faLoginResponse()
    message.success = object.success ?? false
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.user =
      object.user !== undefined && object.user !== null ? User.fromPartial(object.user) : undefined
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseDisable2faRequest(): Disable2faRequest {
  return { currentPassword: undefined, totpCode: undefined, backupCode: undefined }
}

export const Disable2faRequest: MessageFns<Disable2faRequest> = {
  encode(message: Disable2faRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currentPassword !== undefined) {
      writer.uint32(10).string(message.currentPassword)
    }
    if (message.totpCode !== undefined) {
      writer.uint32(18).string(message.totpCode)
    }
    if (message.backupCode !== undefined) {
      writer.uint32(26).string(message.backupCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Disable2faRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDisable2faRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.currentPassword = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.totpCode = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.backupCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Disable2faRequest {
    return {
      currentPassword: isSet(object.currentPassword)
        ? globalThis.String(object.currentPassword)
        : isSet(object.current_password)
          ? globalThis.String(object.current_password)
          : undefined,
      totpCode: isSet(object.totpCode)
        ? globalThis.String(object.totpCode)
        : isSet(object.totp_code)
          ? globalThis.String(object.totp_code)
          : undefined,
      backupCode: isSet(object.backupCode)
        ? globalThis.String(object.backupCode)
        : isSet(object.backup_code)
          ? globalThis.String(object.backup_code)
          : undefined,
    }
  },

  toJSON(message: Disable2faRequest): unknown {
    const obj: any = {}
    if (message.currentPassword !== undefined) {
      obj.currentPassword = message.currentPassword
    }
    if (message.totpCode !== undefined) {
      obj.totpCode = message.totpCode
    }
    if (message.backupCode !== undefined) {
      obj.backupCode = message.backupCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Disable2faRequest>, I>>(base?: I): Disable2faRequest {
    return Disable2faRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Disable2faRequest>, I>>(object: I): Disable2faRequest {
    const message = createBaseDisable2faRequest()
    message.currentPassword = object.currentPassword ?? undefined
    message.totpCode = object.totpCode ?? undefined
    message.backupCode = object.backupCode ?? undefined
    return message
  },
}

function createBaseDisable2faResponse(): Disable2faResponse {
  return {
    success: false,
    errorMessage: undefined,
    accessToken: undefined,
    refreshToken: undefined,
    accessExpiresIn: undefined,
    refreshExpiresIn: undefined,
  }
}

export const Disable2faResponse: MessageFns<Disable2faResponse> = {
  encode(message: Disable2faResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(26).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(34).string(message.refreshToken)
    }
    if (message.accessExpiresIn !== undefined) {
      writer.uint32(40).int64(message.accessExpiresIn)
    }
    if (message.refreshExpiresIn !== undefined) {
      writer.uint32(48).int64(message.refreshExpiresIn)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Disable2faResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDisable2faResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.accessExpiresIn = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.refreshExpiresIn = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Disable2faResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      accessExpiresIn: isSet(object.accessExpiresIn)
        ? globalThis.String(object.accessExpiresIn)
        : isSet(object.access_expires_in)
          ? globalThis.String(object.access_expires_in)
          : undefined,
      refreshExpiresIn: isSet(object.refreshExpiresIn)
        ? globalThis.String(object.refreshExpiresIn)
        : isSet(object.refresh_expires_in)
          ? globalThis.String(object.refresh_expires_in)
          : undefined,
    }
  },

  toJSON(message: Disable2faResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.accessExpiresIn !== undefined) {
      obj.accessExpiresIn = message.accessExpiresIn
    }
    if (message.refreshExpiresIn !== undefined) {
      obj.refreshExpiresIn = message.refreshExpiresIn
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Disable2faResponse>, I>>(base?: I): Disable2faResponse {
    return Disable2faResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Disable2faResponse>, I>>(object: I): Disable2faResponse {
    const message = createBaseDisable2faResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.accessExpiresIn = object.accessExpiresIn ?? undefined
    message.refreshExpiresIn = object.refreshExpiresIn ?? undefined
    return message
  },
}

function createBaseGet2faBackupCodesRequest(): Get2faBackupCodesRequest {
  return {}
}

export const Get2faBackupCodesRequest: MessageFns<Get2faBackupCodesRequest> = {
  encode(_: Get2faBackupCodesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Get2faBackupCodesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGet2faBackupCodesRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): Get2faBackupCodesRequest {
    return {}
  },

  toJSON(_: Get2faBackupCodesRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<Get2faBackupCodesRequest>, I>>(
    base?: I
  ): Get2faBackupCodesRequest {
    return Get2faBackupCodesRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Get2faBackupCodesRequest>, I>>(
    _: I
  ): Get2faBackupCodesRequest {
    const message = createBaseGet2faBackupCodesRequest()
    return message
  },
}

function createBaseGet2faBackupCodesResponse(): Get2faBackupCodesResponse {
  return { success: false, backupCodes: [], errorMessage: undefined }
}

export const Get2faBackupCodesResponse: MessageFns<Get2faBackupCodesResponse> = {
  encode(
    message: Get2faBackupCodesResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    for (const v of message.backupCodes) {
      writer.uint32(18).string(v!)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(26).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Get2faBackupCodesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGet2faBackupCodesResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.backupCodes.push(reader.string())
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Get2faBackupCodesResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      backupCodes: globalThis.Array.isArray(object?.backupCodes)
        ? object.backupCodes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.backup_codes)
          ? object.backup_codes.map((e: any) => globalThis.String(e))
          : [],
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: Get2faBackupCodesResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.backupCodes?.length) {
      obj.backupCodes = message.backupCodes
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Get2faBackupCodesResponse>, I>>(
    base?: I
  ): Get2faBackupCodesResponse {
    return Get2faBackupCodesResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Get2faBackupCodesResponse>, I>>(
    object: I
  ): Get2faBackupCodesResponse {
    const message = createBaseGet2faBackupCodesResponse()
    message.success = object.success ?? false
    message.backupCodes = object.backupCodes?.map((e) => e) || []
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseSetupPasskeyRequest(): SetupPasskeyRequest {
  return { currentPassword: '', totpCode: undefined, backupCode: undefined, emailCode: undefined }
}

export const SetupPasskeyRequest: MessageFns<SetupPasskeyRequest> = {
  encode(message: SetupPasskeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currentPassword !== '') {
      writer.uint32(10).string(message.currentPassword)
    }
    if (message.totpCode !== undefined) {
      writer.uint32(18).string(message.totpCode)
    }
    if (message.backupCode !== undefined) {
      writer.uint32(26).string(message.backupCode)
    }
    if (message.emailCode !== undefined) {
      writer.uint32(34).string(message.emailCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetupPasskeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSetupPasskeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.currentPassword = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.totpCode = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.backupCode = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.emailCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SetupPasskeyRequest {
    return {
      currentPassword: isSet(object.currentPassword)
        ? globalThis.String(object.currentPassword)
        : isSet(object.current_password)
          ? globalThis.String(object.current_password)
          : '',
      totpCode: isSet(object.totpCode)
        ? globalThis.String(object.totpCode)
        : isSet(object.totp_code)
          ? globalThis.String(object.totp_code)
          : undefined,
      backupCode: isSet(object.backupCode)
        ? globalThis.String(object.backupCode)
        : isSet(object.backup_code)
          ? globalThis.String(object.backup_code)
          : undefined,
      emailCode: isSet(object.emailCode)
        ? globalThis.String(object.emailCode)
        : isSet(object.email_code)
          ? globalThis.String(object.email_code)
          : undefined,
    }
  },

  toJSON(message: SetupPasskeyRequest): unknown {
    const obj: any = {}
    if (message.currentPassword !== '') {
      obj.currentPassword = message.currentPassword
    }
    if (message.totpCode !== undefined) {
      obj.totpCode = message.totpCode
    }
    if (message.backupCode !== undefined) {
      obj.backupCode = message.backupCode
    }
    if (message.emailCode !== undefined) {
      obj.emailCode = message.emailCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SetupPasskeyRequest>, I>>(base?: I): SetupPasskeyRequest {
    return SetupPasskeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SetupPasskeyRequest>, I>>(
    object: I
  ): SetupPasskeyRequest {
    const message = createBaseSetupPasskeyRequest()
    message.currentPassword = object.currentPassword ?? ''
    message.totpCode = object.totpCode ?? undefined
    message.backupCode = object.backupCode ?? undefined
    message.emailCode = object.emailCode ?? undefined
    return message
  },
}

function createBaseSetupPasskeyResponse(): SetupPasskeyResponse {
  return {
    success: false,
    challenge: undefined,
    userId: undefined,
    errorMessage: undefined,
    sessionId: undefined,
    existingCredentialIds: [],
  }
}

export const SetupPasskeyResponse: MessageFns<SetupPasskeyResponse> = {
  encode(message: SetupPasskeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.challenge !== undefined) {
      writer.uint32(18).string(message.challenge)
    }
    if (message.userId !== undefined) {
      writer.uint32(26).string(message.userId)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(34).string(message.errorMessage)
    }
    if (message.sessionId !== undefined) {
      writer.uint32(42).string(message.sessionId)
    }
    for (const v of message.existingCredentialIds) {
      writer.uint32(50).string(v!)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetupPasskeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSetupPasskeyResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.challenge = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.userId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.existingCredentialIds.push(reader.string())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SetupPasskeyResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      challenge: isSet(object.challenge) ? globalThis.String(object.challenge) : undefined,
      userId: isSet(object.userId)
        ? globalThis.String(object.userId)
        : isSet(object.user_id)
          ? globalThis.String(object.user_id)
          : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : undefined,
      existingCredentialIds: globalThis.Array.isArray(object?.existingCredentialIds)
        ? object.existingCredentialIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.existing_credential_ids)
          ? object.existing_credential_ids.map((e: any) => globalThis.String(e))
          : [],
    }
  },

  toJSON(message: SetupPasskeyResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.challenge !== undefined) {
      obj.challenge = message.challenge
    }
    if (message.userId !== undefined) {
      obj.userId = message.userId
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.sessionId !== undefined) {
      obj.sessionId = message.sessionId
    }
    if (message.existingCredentialIds?.length) {
      obj.existingCredentialIds = message.existingCredentialIds
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SetupPasskeyResponse>, I>>(base?: I): SetupPasskeyResponse {
    return SetupPasskeyResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SetupPasskeyResponse>, I>>(
    object: I
  ): SetupPasskeyResponse {
    const message = createBaseSetupPasskeyResponse()
    message.success = object.success ?? false
    message.challenge = object.challenge ?? undefined
    message.userId = object.userId ?? undefined
    message.errorMessage = object.errorMessage ?? undefined
    message.sessionId = object.sessionId ?? undefined
    message.existingCredentialIds = object.existingCredentialIds?.map((e) => e) || []
    return message
  },
}

function createBaseConfirmPasskeySetupRequest(): ConfirmPasskeySetupRequest {
  return {
    credentialId: '',
    publicKey: '',
    attestationObject: '',
    clientDataJson: '',
    deviceName: '',
    sessionId: '',
  }
}

export const ConfirmPasskeySetupRequest: MessageFns<ConfirmPasskeySetupRequest> = {
  encode(
    message: ConfirmPasskeySetupRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.credentialId !== '') {
      writer.uint32(10).string(message.credentialId)
    }
    if (message.publicKey !== '') {
      writer.uint32(18).string(message.publicKey)
    }
    if (message.attestationObject !== '') {
      writer.uint32(26).string(message.attestationObject)
    }
    if (message.clientDataJson !== '') {
      writer.uint32(34).string(message.clientDataJson)
    }
    if (message.deviceName !== '') {
      writer.uint32(42).string(message.deviceName)
    }
    if (message.sessionId !== '') {
      writer.uint32(50).string(message.sessionId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmPasskeySetupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmPasskeySetupRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.credentialId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.publicKey = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.attestationObject = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.clientDataJson = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.deviceName = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmPasskeySetupRequest {
    return {
      credentialId: isSet(object.credentialId)
        ? globalThis.String(object.credentialId)
        : isSet(object.credential_id)
          ? globalThis.String(object.credential_id)
          : '',
      publicKey: isSet(object.publicKey)
        ? globalThis.String(object.publicKey)
        : isSet(object.public_key)
          ? globalThis.String(object.public_key)
          : '',
      attestationObject: isSet(object.attestationObject)
        ? globalThis.String(object.attestationObject)
        : isSet(object.attestation_object)
          ? globalThis.String(object.attestation_object)
          : '',
      clientDataJson: isSet(object.clientDataJson)
        ? globalThis.String(object.clientDataJson)
        : isSet(object.client_data_json)
          ? globalThis.String(object.client_data_json)
          : '',
      deviceName: isSet(object.deviceName)
        ? globalThis.String(object.deviceName)
        : isSet(object.device_name)
          ? globalThis.String(object.device_name)
          : '',
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : '',
    }
  },

  toJSON(message: ConfirmPasskeySetupRequest): unknown {
    const obj: any = {}
    if (message.credentialId !== '') {
      obj.credentialId = message.credentialId
    }
    if (message.publicKey !== '') {
      obj.publicKey = message.publicKey
    }
    if (message.attestationObject !== '') {
      obj.attestationObject = message.attestationObject
    }
    if (message.clientDataJson !== '') {
      obj.clientDataJson = message.clientDataJson
    }
    if (message.deviceName !== '') {
      obj.deviceName = message.deviceName
    }
    if (message.sessionId !== '') {
      obj.sessionId = message.sessionId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmPasskeySetupRequest>, I>>(
    base?: I
  ): ConfirmPasskeySetupRequest {
    return ConfirmPasskeySetupRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmPasskeySetupRequest>, I>>(
    object: I
  ): ConfirmPasskeySetupRequest {
    const message = createBaseConfirmPasskeySetupRequest()
    message.credentialId = object.credentialId ?? ''
    message.publicKey = object.publicKey ?? ''
    message.attestationObject = object.attestationObject ?? ''
    message.clientDataJson = object.clientDataJson ?? ''
    message.deviceName = object.deviceName ?? ''
    message.sessionId = object.sessionId ?? ''
    return message
  },
}

function createBaseConfirmPasskeySetupResponse(): ConfirmPasskeySetupResponse {
  return { success: false, errorMessage: undefined }
}

export const ConfirmPasskeySetupResponse: MessageFns<ConfirmPasskeySetupResponse> = {
  encode(
    message: ConfirmPasskeySetupResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmPasskeySetupResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmPasskeySetupResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmPasskeySetupResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: ConfirmPasskeySetupResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmPasskeySetupResponse>, I>>(
    base?: I
  ): ConfirmPasskeySetupResponse {
    return ConfirmPasskeySetupResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmPasskeySetupResponse>, I>>(
    object: I
  ): ConfirmPasskeySetupResponse {
    const message = createBaseConfirmPasskeySetupResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBasePasskeyLoginRequest(): PasskeyLoginRequest {
  return { email: undefined }
}

export const PasskeyLoginRequest: MessageFns<PasskeyLoginRequest> = {
  encode(message: PasskeyLoginRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== undefined) {
      writer.uint32(10).string(message.email)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PasskeyLoginRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePasskeyLoginRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.email = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PasskeyLoginRequest {
    return { email: isSet(object.email) ? globalThis.String(object.email) : undefined }
  },

  toJSON(message: PasskeyLoginRequest): unknown {
    const obj: any = {}
    if (message.email !== undefined) {
      obj.email = message.email
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PasskeyLoginRequest>, I>>(base?: I): PasskeyLoginRequest {
    return PasskeyLoginRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PasskeyLoginRequest>, I>>(
    object: I
  ): PasskeyLoginRequest {
    const message = createBasePasskeyLoginRequest()
    message.email = object.email ?? undefined
    return message
  },
}

function createBasePasskeyLoginResponse(): PasskeyLoginResponse {
  return {
    success: false,
    challenge: undefined,
    sessionId: undefined,
    credentialIds: [],
    errorMessage: undefined,
  }
}

export const PasskeyLoginResponse: MessageFns<PasskeyLoginResponse> = {
  encode(message: PasskeyLoginResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.challenge !== undefined) {
      writer.uint32(18).string(message.challenge)
    }
    if (message.sessionId !== undefined) {
      writer.uint32(26).string(message.sessionId)
    }
    for (const v of message.credentialIds) {
      writer.uint32(34).string(v!)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(42).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PasskeyLoginResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePasskeyLoginResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.challenge = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.credentialIds.push(reader.string())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PasskeyLoginResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      challenge: isSet(object.challenge) ? globalThis.String(object.challenge) : undefined,
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : undefined,
      credentialIds: globalThis.Array.isArray(object?.credentialIds)
        ? object.credentialIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.credential_ids)
          ? object.credential_ids.map((e: any) => globalThis.String(e))
          : [],
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: PasskeyLoginResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.challenge !== undefined) {
      obj.challenge = message.challenge
    }
    if (message.sessionId !== undefined) {
      obj.sessionId = message.sessionId
    }
    if (message.credentialIds?.length) {
      obj.credentialIds = message.credentialIds
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PasskeyLoginResponse>, I>>(base?: I): PasskeyLoginResponse {
    return PasskeyLoginResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PasskeyLoginResponse>, I>>(
    object: I
  ): PasskeyLoginResponse {
    const message = createBasePasskeyLoginResponse()
    message.success = object.success ?? false
    message.challenge = object.challenge ?? undefined
    message.sessionId = object.sessionId ?? undefined
    message.credentialIds = object.credentialIds?.map((e) => e) || []
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseConfirmPasskeyLoginRequest(): ConfirmPasskeyLoginRequest {
  return {
    sessionId: '',
    credentialId: '',
    authenticatorData: '',
    clientDataJson: '',
    signature: '',
    deviceId: undefined,
  }
}

export const ConfirmPasskeyLoginRequest: MessageFns<ConfirmPasskeyLoginRequest> = {
  encode(
    message: ConfirmPasskeyLoginRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.sessionId !== '') {
      writer.uint32(10).string(message.sessionId)
    }
    if (message.credentialId !== '') {
      writer.uint32(18).string(message.credentialId)
    }
    if (message.authenticatorData !== '') {
      writer.uint32(26).string(message.authenticatorData)
    }
    if (message.clientDataJson !== '') {
      writer.uint32(34).string(message.clientDataJson)
    }
    if (message.signature !== '') {
      writer.uint32(42).string(message.signature)
    }
    if (message.deviceId !== undefined) {
      writer.uint32(50).string(message.deviceId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmPasskeyLoginRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmPasskeyLoginRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.credentialId = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.authenticatorData = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.clientDataJson = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.signature = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.deviceId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmPasskeyLoginRequest {
    return {
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : '',
      credentialId: isSet(object.credentialId)
        ? globalThis.String(object.credentialId)
        : isSet(object.credential_id)
          ? globalThis.String(object.credential_id)
          : '',
      authenticatorData: isSet(object.authenticatorData)
        ? globalThis.String(object.authenticatorData)
        : isSet(object.authenticator_data)
          ? globalThis.String(object.authenticator_data)
          : '',
      clientDataJson: isSet(object.clientDataJson)
        ? globalThis.String(object.clientDataJson)
        : isSet(object.client_data_json)
          ? globalThis.String(object.client_data_json)
          : '',
      signature: isSet(object.signature) ? globalThis.String(object.signature) : '',
      deviceId: isSet(object.deviceId)
        ? globalThis.String(object.deviceId)
        : isSet(object.device_id)
          ? globalThis.String(object.device_id)
          : undefined,
    }
  },

  toJSON(message: ConfirmPasskeyLoginRequest): unknown {
    const obj: any = {}
    if (message.sessionId !== '') {
      obj.sessionId = message.sessionId
    }
    if (message.credentialId !== '') {
      obj.credentialId = message.credentialId
    }
    if (message.authenticatorData !== '') {
      obj.authenticatorData = message.authenticatorData
    }
    if (message.clientDataJson !== '') {
      obj.clientDataJson = message.clientDataJson
    }
    if (message.signature !== '') {
      obj.signature = message.signature
    }
    if (message.deviceId !== undefined) {
      obj.deviceId = message.deviceId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmPasskeyLoginRequest>, I>>(
    base?: I
  ): ConfirmPasskeyLoginRequest {
    return ConfirmPasskeyLoginRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmPasskeyLoginRequest>, I>>(
    object: I
  ): ConfirmPasskeyLoginRequest {
    const message = createBaseConfirmPasskeyLoginRequest()
    message.sessionId = object.sessionId ?? ''
    message.credentialId = object.credentialId ?? ''
    message.authenticatorData = object.authenticatorData ?? ''
    message.clientDataJson = object.clientDataJson ?? ''
    message.signature = object.signature ?? ''
    message.deviceId = object.deviceId ?? undefined
    return message
  },
}

function createBaseConfirmPasskeyLoginResponse(): ConfirmPasskeyLoginResponse {
  return {
    success: false,
    accessToken: undefined,
    refreshToken: undefined,
    user: undefined,
    errorMessage: undefined,
  }
}

export const ConfirmPasskeyLoginResponse: MessageFns<ConfirmPasskeyLoginResponse> = {
  encode(
    message: ConfirmPasskeyLoginResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(18).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(26).string(message.refreshToken)
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(34).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(42).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfirmPasskeyLoginResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConfirmPasskeyLoginResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.user = User.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConfirmPasskeyLoginResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: ConfirmPasskeyLoginResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConfirmPasskeyLoginResponse>, I>>(
    base?: I
  ): ConfirmPasskeyLoginResponse {
    return ConfirmPasskeyLoginResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConfirmPasskeyLoginResponse>, I>>(
    object: I
  ): ConfirmPasskeyLoginResponse {
    const message = createBaseConfirmPasskeyLoginResponse()
    message.success = object.success ?? false
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.user =
      object.user !== undefined && object.user !== null ? User.fromPartial(object.user) : undefined
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseDeletePasskeyRequest(): DeletePasskeyRequest {
  return {
    credentialId: '',
    currentPassword: undefined,
    totpCode: undefined,
    backupCode: undefined,
    emailCode: undefined,
  }
}

export const DeletePasskeyRequest: MessageFns<DeletePasskeyRequest> = {
  encode(message: DeletePasskeyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.credentialId !== '') {
      writer.uint32(10).string(message.credentialId)
    }
    if (message.currentPassword !== undefined) {
      writer.uint32(18).string(message.currentPassword)
    }
    if (message.totpCode !== undefined) {
      writer.uint32(26).string(message.totpCode)
    }
    if (message.backupCode !== undefined) {
      writer.uint32(34).string(message.backupCode)
    }
    if (message.emailCode !== undefined) {
      writer.uint32(42).string(message.emailCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePasskeyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeletePasskeyRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.credentialId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.currentPassword = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.totpCode = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.backupCode = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.emailCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeletePasskeyRequest {
    return {
      credentialId: isSet(object.credentialId)
        ? globalThis.String(object.credentialId)
        : isSet(object.credential_id)
          ? globalThis.String(object.credential_id)
          : '',
      currentPassword: isSet(object.currentPassword)
        ? globalThis.String(object.currentPassword)
        : isSet(object.current_password)
          ? globalThis.String(object.current_password)
          : undefined,
      totpCode: isSet(object.totpCode)
        ? globalThis.String(object.totpCode)
        : isSet(object.totp_code)
          ? globalThis.String(object.totp_code)
          : undefined,
      backupCode: isSet(object.backupCode)
        ? globalThis.String(object.backupCode)
        : isSet(object.backup_code)
          ? globalThis.String(object.backup_code)
          : undefined,
      emailCode: isSet(object.emailCode)
        ? globalThis.String(object.emailCode)
        : isSet(object.email_code)
          ? globalThis.String(object.email_code)
          : undefined,
    }
  },

  toJSON(message: DeletePasskeyRequest): unknown {
    const obj: any = {}
    if (message.credentialId !== '') {
      obj.credentialId = message.credentialId
    }
    if (message.currentPassword !== undefined) {
      obj.currentPassword = message.currentPassword
    }
    if (message.totpCode !== undefined) {
      obj.totpCode = message.totpCode
    }
    if (message.backupCode !== undefined) {
      obj.backupCode = message.backupCode
    }
    if (message.emailCode !== undefined) {
      obj.emailCode = message.emailCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeletePasskeyRequest>, I>>(base?: I): DeletePasskeyRequest {
    return DeletePasskeyRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeletePasskeyRequest>, I>>(
    object: I
  ): DeletePasskeyRequest {
    const message = createBaseDeletePasskeyRequest()
    message.credentialId = object.credentialId ?? ''
    message.currentPassword = object.currentPassword ?? undefined
    message.totpCode = object.totpCode ?? undefined
    message.backupCode = object.backupCode ?? undefined
    message.emailCode = object.emailCode ?? undefined
    return message
  },
}

function createBaseDeletePasskeyResponse(): DeletePasskeyResponse {
  return {
    success: false,
    errorMessage: undefined,
    accessToken: undefined,
    refreshToken: undefined,
    accessExpiresIn: undefined,
    refreshExpiresIn: undefined,
  }
}

export const DeletePasskeyResponse: MessageFns<DeletePasskeyResponse> = {
  encode(message: DeletePasskeyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(26).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(34).string(message.refreshToken)
    }
    if (message.accessExpiresIn !== undefined) {
      writer.uint32(40).int64(message.accessExpiresIn)
    }
    if (message.refreshExpiresIn !== undefined) {
      writer.uint32(48).int64(message.refreshExpiresIn)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePasskeyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeletePasskeyResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.accessExpiresIn = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.refreshExpiresIn = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeletePasskeyResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      accessExpiresIn: isSet(object.accessExpiresIn)
        ? globalThis.String(object.accessExpiresIn)
        : isSet(object.access_expires_in)
          ? globalThis.String(object.access_expires_in)
          : undefined,
      refreshExpiresIn: isSet(object.refreshExpiresIn)
        ? globalThis.String(object.refreshExpiresIn)
        : isSet(object.refresh_expires_in)
          ? globalThis.String(object.refresh_expires_in)
          : undefined,
    }
  },

  toJSON(message: DeletePasskeyResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.accessExpiresIn !== undefined) {
      obj.accessExpiresIn = message.accessExpiresIn
    }
    if (message.refreshExpiresIn !== undefined) {
      obj.refreshExpiresIn = message.refreshExpiresIn
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeletePasskeyResponse>, I>>(base?: I): DeletePasskeyResponse {
    return DeletePasskeyResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeletePasskeyResponse>, I>>(
    object: I
  ): DeletePasskeyResponse {
    const message = createBaseDeletePasskeyResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.accessExpiresIn = object.accessExpiresIn ?? undefined
    message.refreshExpiresIn = object.refreshExpiresIn ?? undefined
    return message
  },
}

function createBaseSendStepUpCodeRequest(): SendStepUpCodeRequest {
  return { action: 0 }
}

export const SendStepUpCodeRequest: MessageFns<SendStepUpCodeRequest> = {
  encode(message: SendStepUpCodeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.action !== 0) {
      writer.uint32(8).int32(message.action)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendStepUpCodeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSendStepUpCodeRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.action = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SendStepUpCodeRequest {
    return { action: isSet(object.action) ? sensitiveActionFromJSON(object.action) : 0 }
  },

  toJSON(message: SendStepUpCodeRequest): unknown {
    const obj: any = {}
    if (message.action !== 0) {
      obj.action = sensitiveActionToJSON(message.action)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SendStepUpCodeRequest>, I>>(base?: I): SendStepUpCodeRequest {
    return SendStepUpCodeRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SendStepUpCodeRequest>, I>>(
    object: I
  ): SendStepUpCodeRequest {
    const message = createBaseSendStepUpCodeRequest()
    message.action = object.action ?? 0
    return message
  },
}

function createBaseSendStepUpCodeResponse(): SendStepUpCodeResponse {
  return { success: false, errorMessage: undefined }
}

export const SendStepUpCodeResponse: MessageFns<SendStepUpCodeResponse> = {
  encode(message: SendStepUpCodeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendStepUpCodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSendStepUpCodeResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SendStepUpCodeResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: SendStepUpCodeResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SendStepUpCodeResponse>, I>>(
    base?: I
  ): SendStepUpCodeResponse {
    return SendStepUpCodeResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SendStepUpCodeResponse>, I>>(
    object: I
  ): SendStepUpCodeResponse {
    const message = createBaseSendStepUpCodeResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseGetUserPasskeysRequest(): GetUserPasskeysRequest {
  return {}
}

export const GetUserPasskeysRequest: MessageFns<GetUserPasskeysRequest> = {
  encode(_: GetUserPasskeysRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserPasskeysRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetUserPasskeysRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): GetUserPasskeysRequest {
    return {}
  },

  toJSON(_: GetUserPasskeysRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<GetUserPasskeysRequest>, I>>(
    base?: I
  ): GetUserPasskeysRequest {
    return GetUserPasskeysRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetUserPasskeysRequest>, I>>(
    _: I
  ): GetUserPasskeysRequest {
    const message = createBaseGetUserPasskeysRequest()
    return message
  },
}

function createBasePasskeyInfo(): PasskeyInfo {
  return { credentialId: '', credentialName: '', createdAt: '0', lastUsedAt: undefined }
}

export const PasskeyInfo: MessageFns<PasskeyInfo> = {
  encode(message: PasskeyInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.credentialId !== '') {
      writer.uint32(10).string(message.credentialId)
    }
    if (message.credentialName !== '') {
      writer.uint32(18).string(message.credentialName)
    }
    if (message.createdAt !== '0') {
      writer.uint32(24).int64(message.createdAt)
    }
    if (message.lastUsedAt !== undefined) {
      writer.uint32(32).int64(message.lastUsedAt)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PasskeyInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePasskeyInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.credentialId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.credentialName = reader.string()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 4: {
          if (tag !== 32) {
            break
          }

          message.lastUsedAt = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PasskeyInfo {
    return {
      credentialId: isSet(object.credentialId)
        ? globalThis.String(object.credentialId)
        : isSet(object.credential_id)
          ? globalThis.String(object.credential_id)
          : '',
      credentialName: isSet(object.credentialName)
        ? globalThis.String(object.credentialName)
        : isSet(object.credential_name)
          ? globalThis.String(object.credential_name)
          : '',
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      lastUsedAt: isSet(object.lastUsedAt)
        ? globalThis.String(object.lastUsedAt)
        : isSet(object.last_used_at)
          ? globalThis.String(object.last_used_at)
          : undefined,
    }
  },

  toJSON(message: PasskeyInfo): unknown {
    const obj: any = {}
    if (message.credentialId !== '') {
      obj.credentialId = message.credentialId
    }
    if (message.credentialName !== '') {
      obj.credentialName = message.credentialName
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.lastUsedAt !== undefined) {
      obj.lastUsedAt = message.lastUsedAt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PasskeyInfo>, I>>(base?: I): PasskeyInfo {
    return PasskeyInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PasskeyInfo>, I>>(object: I): PasskeyInfo {
    const message = createBasePasskeyInfo()
    message.credentialId = object.credentialId ?? ''
    message.credentialName = object.credentialName ?? ''
    message.createdAt = object.createdAt ?? '0'
    message.lastUsedAt = object.lastUsedAt ?? undefined
    return message
  },
}

function createBaseGetUserPasskeysResponse(): GetUserPasskeysResponse {
  return { success: false, passkeys: [], errorMessage: undefined }
}

export const GetUserPasskeysResponse: MessageFns<GetUserPasskeysResponse> = {
  encode(
    message: GetUserPasskeysResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    for (const v of message.passkeys) {
      PasskeyInfo.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(26).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserPasskeysResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetUserPasskeysResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.passkeys.push(PasskeyInfo.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetUserPasskeysResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      passkeys: globalThis.Array.isArray(object?.passkeys)
        ? object.passkeys.map((e: any) => PasskeyInfo.fromJSON(e))
        : [],
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: GetUserPasskeysResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.passkeys?.length) {
      obj.passkeys = message.passkeys.map((e) => PasskeyInfo.toJSON(e))
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetUserPasskeysResponse>, I>>(
    base?: I
  ): GetUserPasskeysResponse {
    return GetUserPasskeysResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetUserPasskeysResponse>, I>>(
    object: I
  ): GetUserPasskeysResponse {
    const message = createBaseGetUserPasskeysResponse()
    message.success = object.success ?? false
    message.passkeys = object.passkeys?.map((e) => PasskeyInfo.fromPartial(e)) || []
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseEnhancedLoginResponse(): EnhancedLoginResponse {
  return {
    success: false,
    requires2fa: false,
    requiresPasskey: false,
    sessionId: undefined,
    accessToken: undefined,
    refreshToken: undefined,
    user: undefined,
    errorMessage: undefined,
  }
}

export const EnhancedLoginResponse: MessageFns<EnhancedLoginResponse> = {
  encode(message: EnhancedLoginResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.requires2fa !== false) {
      writer.uint32(16).bool(message.requires2fa)
    }
    if (message.requiresPasskey !== false) {
      writer.uint32(24).bool(message.requiresPasskey)
    }
    if (message.sessionId !== undefined) {
      writer.uint32(34).string(message.sessionId)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(42).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(50).string(message.refreshToken)
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(58).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(66).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnhancedLoginResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEnhancedLoginResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.requires2fa = reader.bool()
          continue
        }
        case 3: {
          if (tag !== 24) {
            break
          }

          message.requiresPasskey = reader.bool()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.user = User.decode(reader, reader.uint32())
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EnhancedLoginResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      requires2fa: isSet(object.requires2fa)
        ? globalThis.Boolean(object.requires2fa)
        : isSet(object.requires_2fa)
          ? globalThis.Boolean(object.requires_2fa)
          : false,
      requiresPasskey: isSet(object.requiresPasskey)
        ? globalThis.Boolean(object.requiresPasskey)
        : isSet(object.requires_passkey)
          ? globalThis.Boolean(object.requires_passkey)
          : false,
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : undefined,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: EnhancedLoginResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.requires2fa !== false) {
      obj.requires2fa = message.requires2fa
    }
    if (message.requiresPasskey !== false) {
      obj.requiresPasskey = message.requiresPasskey
    }
    if (message.sessionId !== undefined) {
      obj.sessionId = message.sessionId
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EnhancedLoginResponse>, I>>(base?: I): EnhancedLoginResponse {
    return EnhancedLoginResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EnhancedLoginResponse>, I>>(
    object: I
  ): EnhancedLoginResponse {
    const message = createBaseEnhancedLoginResponse()
    message.success = object.success ?? false
    message.requires2fa = object.requires2fa ?? false
    message.requiresPasskey = object.requiresPasskey ?? false
    message.sessionId = object.sessionId ?? undefined
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.user =
      object.user !== undefined && object.user !== null ? User.fromPartial(object.user) : undefined
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseGoogleLoginRequest(): GoogleLoginRequest {
  return { idToken: '', deviceId: undefined }
}

export const GoogleLoginRequest: MessageFns<GoogleLoginRequest> = {
  encode(message: GoogleLoginRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.idToken !== '') {
      writer.uint32(10).string(message.idToken)
    }
    if (message.deviceId !== undefined) {
      writer.uint32(18).string(message.deviceId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleLoginRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGoogleLoginRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.idToken = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.deviceId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GoogleLoginRequest {
    return {
      idToken: isSet(object.idToken)
        ? globalThis.String(object.idToken)
        : isSet(object.id_token)
          ? globalThis.String(object.id_token)
          : '',
      deviceId: isSet(object.deviceId)
        ? globalThis.String(object.deviceId)
        : isSet(object.device_id)
          ? globalThis.String(object.device_id)
          : undefined,
    }
  },

  toJSON(message: GoogleLoginRequest): unknown {
    const obj: any = {}
    if (message.idToken !== '') {
      obj.idToken = message.idToken
    }
    if (message.deviceId !== undefined) {
      obj.deviceId = message.deviceId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GoogleLoginRequest>, I>>(base?: I): GoogleLoginRequest {
    return GoogleLoginRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GoogleLoginRequest>, I>>(object: I): GoogleLoginRequest {
    const message = createBaseGoogleLoginRequest()
    message.idToken = object.idToken ?? ''
    message.deviceId = object.deviceId ?? undefined
    return message
  },
}

function createBaseGoogleLoginResponse(): GoogleLoginResponse {
  return {
    success: false,
    accessToken: undefined,
    refreshToken: undefined,
    user: undefined,
    errorMessage: undefined,
    isNewUser: false,
    requires2fa: false,
    tempToken: undefined,
  }
}

export const GoogleLoginResponse: MessageFns<GoogleLoginResponse> = {
  encode(message: GoogleLoginResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(18).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(26).string(message.refreshToken)
    }
    if (message.user !== undefined) {
      User.encode(message.user, writer.uint32(34).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(42).string(message.errorMessage)
    }
    if (message.isNewUser !== false) {
      writer.uint32(48).bool(message.isNewUser)
    }
    if (message.requires2fa !== false) {
      writer.uint32(56).bool(message.requires2fa)
    }
    if (message.tempToken !== undefined) {
      writer.uint32(66).string(message.tempToken)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GoogleLoginResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGoogleLoginResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.user = User.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.isNewUser = reader.bool()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.requires2fa = reader.bool()
          continue
        }
        case 8: {
          if (tag !== 66) {
            break
          }

          message.tempToken = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GoogleLoginResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      user: isSet(object.user) ? User.fromJSON(object.user) : undefined,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      isNewUser: isSet(object.isNewUser)
        ? globalThis.Boolean(object.isNewUser)
        : isSet(object.is_new_user)
          ? globalThis.Boolean(object.is_new_user)
          : false,
      requires2fa: isSet(object.requires2fa)
        ? globalThis.Boolean(object.requires2fa)
        : isSet(object.requires_2fa)
          ? globalThis.Boolean(object.requires_2fa)
          : false,
      tempToken: isSet(object.tempToken)
        ? globalThis.String(object.tempToken)
        : isSet(object.temp_token)
          ? globalThis.String(object.temp_token)
          : undefined,
    }
  },

  toJSON(message: GoogleLoginResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.user !== undefined) {
      obj.user = User.toJSON(message.user)
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.isNewUser !== false) {
      obj.isNewUser = message.isNewUser
    }
    if (message.requires2fa !== false) {
      obj.requires2fa = message.requires2fa
    }
    if (message.tempToken !== undefined) {
      obj.tempToken = message.tempToken
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GoogleLoginResponse>, I>>(base?: I): GoogleLoginResponse {
    return GoogleLoginResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GoogleLoginResponse>, I>>(
    object: I
  ): GoogleLoginResponse {
    const message = createBaseGoogleLoginResponse()
    message.success = object.success ?? false
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.user =
      object.user !== undefined && object.user !== null ? User.fromPartial(object.user) : undefined
    message.errorMessage = object.errorMessage ?? undefined
    message.isNewUser = object.isNewUser ?? false
    message.requires2fa = object.requires2fa ?? false
    message.tempToken = object.tempToken ?? undefined
    return message
  },
}

function createBaseUserList(): UserList {
  return { users: [] }
}

export const UserList: MessageFns<UserList> = {
  encode(message: UserList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.users) {
      User.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUserList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.users.push(User.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UserList {
    return {
      users: globalThis.Array.isArray(object?.users)
        ? object.users.map((e: any) => User.fromJSON(e))
        : [],
    }
  },

  toJSON(message: UserList): unknown {
    const obj: any = {}
    if (message.users?.length) {
      obj.users = message.users.map((e) => User.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UserList>, I>>(base?: I): UserList {
    return UserList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UserList>, I>>(object: I): UserList {
    const message = createBaseUserList()
    message.users = object.users?.map((e) => User.fromPartial(e)) || []
    return message
  },
}

function createBaseUserAccountList(): UserAccountList {
  return { userAccounts: [] }
}

export const UserAccountList: MessageFns<UserAccountList> = {
  encode(message: UserAccountList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.userAccounts) {
      UserAccount.encode(v!, writer.uint32(10).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserAccountList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUserAccountList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.userAccounts.push(UserAccount.decode(reader, reader.uint32()))
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UserAccountList {
    return {
      userAccounts: globalThis.Array.isArray(object?.userAccounts)
        ? object.userAccounts.map((e: any) => UserAccount.fromJSON(e))
        : globalThis.Array.isArray(object?.user_accounts)
          ? object.user_accounts.map((e: any) => UserAccount.fromJSON(e))
          : [],
    }
  },

  toJSON(message: UserAccountList): unknown {
    const obj: any = {}
    if (message.userAccounts?.length) {
      obj.userAccounts = message.userAccounts.map((e) => UserAccount.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UserAccountList>, I>>(base?: I): UserAccountList {
    return UserAccountList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UserAccountList>, I>>(object: I): UserAccountList {
    const message = createBaseUserAccountList()
    message.userAccounts = object.userAccounts?.map((e) => UserAccount.fromPartial(e)) || []
    return message
  },
}

function createBaseChangePasswordRequest(): ChangePasswordRequest {
  return {
    currentPassword: '',
    newPassword: '',
    totpCode: undefined,
    emailCode: undefined,
    backupCode: undefined,
  }
}

export const ChangePasswordRequest: MessageFns<ChangePasswordRequest> = {
  encode(message: ChangePasswordRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currentPassword !== '') {
      writer.uint32(10).string(message.currentPassword)
    }
    if (message.newPassword !== '') {
      writer.uint32(18).string(message.newPassword)
    }
    if (message.totpCode !== undefined) {
      writer.uint32(26).string(message.totpCode)
    }
    if (message.emailCode !== undefined) {
      writer.uint32(34).string(message.emailCode)
    }
    if (message.backupCode !== undefined) {
      writer.uint32(42).string(message.backupCode)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChangePasswordRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChangePasswordRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.currentPassword = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.newPassword = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.totpCode = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.emailCode = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.backupCode = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChangePasswordRequest {
    return {
      currentPassword: isSet(object.currentPassword)
        ? globalThis.String(object.currentPassword)
        : isSet(object.current_password)
          ? globalThis.String(object.current_password)
          : '',
      newPassword: isSet(object.newPassword)
        ? globalThis.String(object.newPassword)
        : isSet(object.new_password)
          ? globalThis.String(object.new_password)
          : '',
      totpCode: isSet(object.totpCode)
        ? globalThis.String(object.totpCode)
        : isSet(object.totp_code)
          ? globalThis.String(object.totp_code)
          : undefined,
      emailCode: isSet(object.emailCode)
        ? globalThis.String(object.emailCode)
        : isSet(object.email_code)
          ? globalThis.String(object.email_code)
          : undefined,
      backupCode: isSet(object.backupCode)
        ? globalThis.String(object.backupCode)
        : isSet(object.backup_code)
          ? globalThis.String(object.backup_code)
          : undefined,
    }
  },

  toJSON(message: ChangePasswordRequest): unknown {
    const obj: any = {}
    if (message.currentPassword !== '') {
      obj.currentPassword = message.currentPassword
    }
    if (message.newPassword !== '') {
      obj.newPassword = message.newPassword
    }
    if (message.totpCode !== undefined) {
      obj.totpCode = message.totpCode
    }
    if (message.emailCode !== undefined) {
      obj.emailCode = message.emailCode
    }
    if (message.backupCode !== undefined) {
      obj.backupCode = message.backupCode
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChangePasswordRequest>, I>>(base?: I): ChangePasswordRequest {
    return ChangePasswordRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChangePasswordRequest>, I>>(
    object: I
  ): ChangePasswordRequest {
    const message = createBaseChangePasswordRequest()
    message.currentPassword = object.currentPassword ?? ''
    message.newPassword = object.newPassword ?? ''
    message.totpCode = object.totpCode ?? undefined
    message.emailCode = object.emailCode ?? undefined
    message.backupCode = object.backupCode ?? undefined
    return message
  },
}

function createBaseChangePasswordResponse(): ChangePasswordResponse {
  return {
    success: false,
    errorMessage: undefined,
    accessToken: undefined,
    refreshToken: undefined,
    accessExpiresIn: undefined,
    refreshExpiresIn: undefined,
  }
}

export const ChangePasswordResponse: MessageFns<ChangePasswordResponse> = {
  encode(message: ChangePasswordResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(26).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(34).string(message.refreshToken)
    }
    if (message.accessExpiresIn !== undefined) {
      writer.uint32(40).int64(message.accessExpiresIn)
    }
    if (message.refreshExpiresIn !== undefined) {
      writer.uint32(48).int64(message.refreshExpiresIn)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChangePasswordResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChangePasswordResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.accessExpiresIn = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.refreshExpiresIn = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChangePasswordResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      accessExpiresIn: isSet(object.accessExpiresIn)
        ? globalThis.String(object.accessExpiresIn)
        : isSet(object.access_expires_in)
          ? globalThis.String(object.access_expires_in)
          : undefined,
      refreshExpiresIn: isSet(object.refreshExpiresIn)
        ? globalThis.String(object.refreshExpiresIn)
        : isSet(object.refresh_expires_in)
          ? globalThis.String(object.refresh_expires_in)
          : undefined,
    }
  },

  toJSON(message: ChangePasswordResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.accessExpiresIn !== undefined) {
      obj.accessExpiresIn = message.accessExpiresIn
    }
    if (message.refreshExpiresIn !== undefined) {
      obj.refreshExpiresIn = message.refreshExpiresIn
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChangePasswordResponse>, I>>(
    base?: I
  ): ChangePasswordResponse {
    return ChangePasswordResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChangePasswordResponse>, I>>(
    object: I
  ): ChangePasswordResponse {
    const message = createBaseChangePasswordResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.accessExpiresIn = object.accessExpiresIn ?? undefined
    message.refreshExpiresIn = object.refreshExpiresIn ?? undefined
    return message
  },
}

function createBaseSessionInfo(): SessionInfo {
  return {
    sessionId: '',
    deviceLabel: '',
    ip: '',
    geoCountry: undefined,
    geoCity: undefined,
    createdAt: '0',
    lastUsedAt: '0',
    isCurrent: false,
  }
}

export const SessionInfo: MessageFns<SessionInfo> = {
  encode(message: SessionInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionId !== '') {
      writer.uint32(10).string(message.sessionId)
    }
    if (message.deviceLabel !== '') {
      writer.uint32(18).string(message.deviceLabel)
    }
    if (message.ip !== '') {
      writer.uint32(26).string(message.ip)
    }
    if (message.geoCountry !== undefined) {
      writer.uint32(34).string(message.geoCountry)
    }
    if (message.geoCity !== undefined) {
      writer.uint32(42).string(message.geoCity)
    }
    if (message.createdAt !== '0') {
      writer.uint32(48).int64(message.createdAt)
    }
    if (message.lastUsedAt !== '0') {
      writer.uint32(56).int64(message.lastUsedAt)
    }
    if (message.isCurrent !== false) {
      writer.uint32(64).bool(message.isCurrent)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SessionInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSessionInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.deviceLabel = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.ip = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.geoCountry = reader.string()
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.geoCity = reader.string()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.createdAt = reader.int64().toString()
          continue
        }
        case 7: {
          if (tag !== 56) {
            break
          }

          message.lastUsedAt = reader.int64().toString()
          continue
        }
        case 8: {
          if (tag !== 64) {
            break
          }

          message.isCurrent = reader.bool()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SessionInfo {
    return {
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : '',
      deviceLabel: isSet(object.deviceLabel)
        ? globalThis.String(object.deviceLabel)
        : isSet(object.device_label)
          ? globalThis.String(object.device_label)
          : '',
      ip: isSet(object.ip) ? globalThis.String(object.ip) : '',
      geoCountry: isSet(object.geoCountry)
        ? globalThis.String(object.geoCountry)
        : isSet(object.geo_country)
          ? globalThis.String(object.geo_country)
          : undefined,
      geoCity: isSet(object.geoCity)
        ? globalThis.String(object.geoCity)
        : isSet(object.geo_city)
          ? globalThis.String(object.geo_city)
          : undefined,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
          ? globalThis.String(object.created_at)
          : '0',
      lastUsedAt: isSet(object.lastUsedAt)
        ? globalThis.String(object.lastUsedAt)
        : isSet(object.last_used_at)
          ? globalThis.String(object.last_used_at)
          : '0',
      isCurrent: isSet(object.isCurrent)
        ? globalThis.Boolean(object.isCurrent)
        : isSet(object.is_current)
          ? globalThis.Boolean(object.is_current)
          : false,
    }
  },

  toJSON(message: SessionInfo): unknown {
    const obj: any = {}
    if (message.sessionId !== '') {
      obj.sessionId = message.sessionId
    }
    if (message.deviceLabel !== '') {
      obj.deviceLabel = message.deviceLabel
    }
    if (message.ip !== '') {
      obj.ip = message.ip
    }
    if (message.geoCountry !== undefined) {
      obj.geoCountry = message.geoCountry
    }
    if (message.geoCity !== undefined) {
      obj.geoCity = message.geoCity
    }
    if (message.createdAt !== '0') {
      obj.createdAt = message.createdAt
    }
    if (message.lastUsedAt !== '0') {
      obj.lastUsedAt = message.lastUsedAt
    }
    if (message.isCurrent !== false) {
      obj.isCurrent = message.isCurrent
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SessionInfo>, I>>(base?: I): SessionInfo {
    return SessionInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SessionInfo>, I>>(object: I): SessionInfo {
    const message = createBaseSessionInfo()
    message.sessionId = object.sessionId ?? ''
    message.deviceLabel = object.deviceLabel ?? ''
    message.ip = object.ip ?? ''
    message.geoCountry = object.geoCountry ?? undefined
    message.geoCity = object.geoCity ?? undefined
    message.createdAt = object.createdAt ?? '0'
    message.lastUsedAt = object.lastUsedAt ?? '0'
    message.isCurrent = object.isCurrent ?? false
    return message
  },
}

function createBaseListSessionsRequest(): ListSessionsRequest {
  return {}
}

export const ListSessionsRequest: MessageFns<ListSessionsRequest> = {
  encode(_: ListSessionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListSessionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListSessionsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): ListSessionsRequest {
    return {}
  },

  toJSON(_: ListSessionsRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<ListSessionsRequest>, I>>(base?: I): ListSessionsRequest {
    return ListSessionsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListSessionsRequest>, I>>(_: I): ListSessionsRequest {
    const message = createBaseListSessionsRequest()
    return message
  },
}

function createBaseListSessionsResponse(): ListSessionsResponse {
  return { success: false, sessions: [], errorMessage: undefined }
}

export const ListSessionsResponse: MessageFns<ListSessionsResponse> = {
  encode(message: ListSessionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    for (const v of message.sessions) {
      SessionInfo.encode(v!, writer.uint32(18).fork()).join()
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(26).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListSessionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListSessionsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.sessions.push(SessionInfo.decode(reader, reader.uint32()))
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListSessionsResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      sessions: globalThis.Array.isArray(object?.sessions)
        ? object.sessions.map((e: any) => SessionInfo.fromJSON(e))
        : [],
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: ListSessionsResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.sessions?.length) {
      obj.sessions = message.sessions.map((e) => SessionInfo.toJSON(e))
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListSessionsResponse>, I>>(base?: I): ListSessionsResponse {
    return ListSessionsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListSessionsResponse>, I>>(
    object: I
  ): ListSessionsResponse {
    const message = createBaseListSessionsResponse()
    message.success = object.success ?? false
    message.sessions = object.sessions?.map((e) => SessionInfo.fromPartial(e)) || []
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseRevokeSessionRequest(): RevokeSessionRequest {
  return { sessionId: '' }
}

export const RevokeSessionRequest: MessageFns<RevokeSessionRequest> = {
  encode(message: RevokeSessionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sessionId !== '') {
      writer.uint32(10).string(message.sessionId)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeSessionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRevokeSessionRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.sessionId = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RevokeSessionRequest {
    return {
      sessionId: isSet(object.sessionId)
        ? globalThis.String(object.sessionId)
        : isSet(object.session_id)
          ? globalThis.String(object.session_id)
          : '',
    }
  },

  toJSON(message: RevokeSessionRequest): unknown {
    const obj: any = {}
    if (message.sessionId !== '') {
      obj.sessionId = message.sessionId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RevokeSessionRequest>, I>>(base?: I): RevokeSessionRequest {
    return RevokeSessionRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RevokeSessionRequest>, I>>(
    object: I
  ): RevokeSessionRequest {
    const message = createBaseRevokeSessionRequest()
    message.sessionId = object.sessionId ?? ''
    return message
  },
}

function createBaseRevokeSessionResponse(): RevokeSessionResponse {
  return { success: false, errorMessage: undefined }
}

export const RevokeSessionResponse: MessageFns<RevokeSessionResponse> = {
  encode(message: RevokeSessionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeSessionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRevokeSessionResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RevokeSessionResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: RevokeSessionResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RevokeSessionResponse>, I>>(base?: I): RevokeSessionResponse {
    return RevokeSessionResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RevokeSessionResponse>, I>>(
    object: I
  ): RevokeSessionResponse {
    const message = createBaseRevokeSessionResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseLogoutRequest(): LogoutRequest {
  return {}
}

export const LogoutRequest: MessageFns<LogoutRequest> = {
  encode(_: LogoutRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LogoutRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLogoutRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): LogoutRequest {
    return {}
  },

  toJSON(_: LogoutRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<LogoutRequest>, I>>(base?: I): LogoutRequest {
    return LogoutRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LogoutRequest>, I>>(_: I): LogoutRequest {
    const message = createBaseLogoutRequest()
    return message
  },
}

function createBaseLogoutResponse(): LogoutResponse {
  return { success: false, errorMessage: undefined }
}

export const LogoutResponse: MessageFns<LogoutResponse> = {
  encode(message: LogoutResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LogoutResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseLogoutResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): LogoutResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
    }
  },

  toJSON(message: LogoutResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<LogoutResponse>, I>>(base?: I): LogoutResponse {
    return LogoutResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<LogoutResponse>, I>>(object: I): LogoutResponse {
    const message = createBaseLogoutResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    return message
  },
}

function createBaseRevokeAllOtherSessionsRequest(): RevokeAllOtherSessionsRequest {
  return {}
}

export const RevokeAllOtherSessionsRequest: MessageFns<RevokeAllOtherSessionsRequest> = {
  encode(
    _: RevokeAllOtherSessionsRequest,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeAllOtherSessionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRevokeAllOtherSessionsRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(_: any): RevokeAllOtherSessionsRequest {
    return {}
  },

  toJSON(_: RevokeAllOtherSessionsRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<RevokeAllOtherSessionsRequest>, I>>(
    base?: I
  ): RevokeAllOtherSessionsRequest {
    return RevokeAllOtherSessionsRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RevokeAllOtherSessionsRequest>, I>>(
    _: I
  ): RevokeAllOtherSessionsRequest {
    const message = createBaseRevokeAllOtherSessionsRequest()
    return message
  },
}

function createBaseRevokeAllOtherSessionsResponse(): RevokeAllOtherSessionsResponse {
  return {
    success: false,
    errorMessage: undefined,
    accessToken: undefined,
    refreshToken: undefined,
    accessExpiresIn: undefined,
    refreshExpiresIn: undefined,
  }
}

export const RevokeAllOtherSessionsResponse: MessageFns<RevokeAllOtherSessionsResponse> = {
  encode(
    message: RevokeAllOtherSessionsResponse,
    writer: BinaryWriter = new BinaryWriter()
  ): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage)
    }
    if (message.accessToken !== undefined) {
      writer.uint32(26).string(message.accessToken)
    }
    if (message.refreshToken !== undefined) {
      writer.uint32(34).string(message.refreshToken)
    }
    if (message.accessExpiresIn !== undefined) {
      writer.uint32(40).int64(message.accessExpiresIn)
    }
    if (message.refreshExpiresIn !== undefined) {
      writer.uint32(48).int64(message.refreshExpiresIn)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RevokeAllOtherSessionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRevokeAllOtherSessionsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.accessToken = reader.string()
          continue
        }
        case 4: {
          if (tag !== 34) {
            break
          }

          message.refreshToken = reader.string()
          continue
        }
        case 5: {
          if (tag !== 40) {
            break
          }

          message.accessExpiresIn = reader.int64().toString()
          continue
        }
        case 6: {
          if (tag !== 48) {
            break
          }

          message.refreshExpiresIn = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RevokeAllOtherSessionsResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage)
        ? globalThis.String(object.errorMessage)
        : isSet(object.error_message)
          ? globalThis.String(object.error_message)
          : undefined,
      accessToken: isSet(object.accessToken)
        ? globalThis.String(object.accessToken)
        : isSet(object.access_token)
          ? globalThis.String(object.access_token)
          : undefined,
      refreshToken: isSet(object.refreshToken)
        ? globalThis.String(object.refreshToken)
        : isSet(object.refresh_token)
          ? globalThis.String(object.refresh_token)
          : undefined,
      accessExpiresIn: isSet(object.accessExpiresIn)
        ? globalThis.String(object.accessExpiresIn)
        : isSet(object.access_expires_in)
          ? globalThis.String(object.access_expires_in)
          : undefined,
      refreshExpiresIn: isSet(object.refreshExpiresIn)
        ? globalThis.String(object.refreshExpiresIn)
        : isSet(object.refresh_expires_in)
          ? globalThis.String(object.refresh_expires_in)
          : undefined,
    }
  },

  toJSON(message: RevokeAllOtherSessionsResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage
    }
    if (message.accessToken !== undefined) {
      obj.accessToken = message.accessToken
    }
    if (message.refreshToken !== undefined) {
      obj.refreshToken = message.refreshToken
    }
    if (message.accessExpiresIn !== undefined) {
      obj.accessExpiresIn = message.accessExpiresIn
    }
    if (message.refreshExpiresIn !== undefined) {
      obj.refreshExpiresIn = message.refreshExpiresIn
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RevokeAllOtherSessionsResponse>, I>>(
    base?: I
  ): RevokeAllOtherSessionsResponse {
    return RevokeAllOtherSessionsResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RevokeAllOtherSessionsResponse>, I>>(
    object: I
  ): RevokeAllOtherSessionsResponse {
    const message = createBaseRevokeAllOtherSessionsResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? undefined
    message.accessToken = object.accessToken ?? undefined
    message.refreshToken = object.refreshToken ?? undefined
    message.accessExpiresIn = object.accessExpiresIn ?? undefined
    message.refreshExpiresIn = object.refreshExpiresIn ?? undefined
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
